import React, { useState } from 'react';
import styles from '../Faq.module.scss';
import cx from 'classnames';
import { ChevronRight, ChevronDown } from 'react-feather';

const FaqItem = ({ title, children }) => {

    const [active, setActive] = useState(false)

    return (
        <li className={styles.faq}>
            <h4 className={styles.faqTitle} onClick={() => setActive(active ? false : true)}>
                {active? <ChevronDown /> : <ChevronRight /> } {title}
            </h4>
            <div className={cx(styles.faqContent, {[styles.faqContentActive]: active})}>
                <div className={styles.faqContentInner}>{children}</div>
            </div>
        </li>
    )
}

export default FaqItem;